import PageNotFound from "@/pages/404";
import About from "@/pages/About";
import Article from "@/pages/Article";
import Case from "@/pages/Case";
import Contact from "@/pages/Contact";
import Home from "@/pages/Home";
import Jobs from "@/pages/Jobs";
import JobsPreview from "@/pages/JobsPreview";
import Join from "@/pages/Join";
import Leadership from "@/pages/Leadership";
import News from "@/pages/News";
import PostPreview from "@/pages/PostPreview";
import Privacy from "@/pages/Privacy";
import Services from "@/pages/Services";
import SimplePage from "@/pages/SimplePage";
import TermsAndConditions from "@/pages/TermsAndConditions";
import Work from "@/pages/Work";
import LandingPage from "@/pages/LandingPage";
import CasePreview from "@/pages/CasePreview";

export const emea = [
  {
    path: "/",
    name: "home-page",
    component: Home,
    meta: {
      title: "Home",
    },
  },
  {
    name: "post-preview",
    path: "/post-preview/:id/:preview_key",
    component: PostPreview,
  },
  {
    name: "post-preview-jobs",
    path: "/post-preview-jobs/:id/:preview_key",
    component: JobsPreview,
  },
  {
    name: "post-preview-case-studies",
    path: "/post-preview-case-studies/:id/:preview_key",
    component: CasePreview,
  },
  {
    path: "/our-work",
    name: "work-page",
    component: Work,
    meta: {
      title: "Work",
    },
    props: {
      slug: "our-work",
    },
  },
  {
    path: "/services/:slug?",
    name: "services-page",
    component: Services,
    meta: {
      title: "Services",
    },
    props: {
      slug_carousel: "our-work",
    },
  },
  {
    path: "/services",
    name: "services-page",
    component: Services,
    meta: {
      title: "Services",
    },
    props: {
      slug_carousel: "our-work",
    },
  },
  {
    path: "/about-us",
    name: "about-page",
    component: About,
    meta: {
      title: "About",
    },
    props: {
      slug: "about-us",
    },
  },
  {
    path: "/news",
    name: "news-page",
    component: News,
    meta: {
      title: "News",
    },
  },
  {
    path: "/workatweber",
    name: "workatweber",
    component: Join,
    meta: {
      title: "#WORKATWEBER",
    },
    props: {
      slug: "workatweber",
    },
  },
  {
    path: "/privacy-policy",
    name: "privacy-page",
    component: Privacy,
    meta: {
      title: "Privacy Policy",
    },
  },
  {
    path: "/website-privacy-notice-and-cookie-policy",
    name: "privacy-page",
    component: Privacy,
    props: {
      slug: "website-privacy-notice-and-cookie-policy",
    },
  },
  {
    path: "/company-details-and-website-terms-of-use/",
    name: "website-terms-of-use",
    component: TermsAndConditions,
    props: {
      slug: "company-details-and-website-terms-of-use",
    },
  },
  {
    path: "/terms-and-conditions/",
    name: "terms-and-conditions",
    component: TermsAndConditions,
    props: {
      slug: "terms-and-conditions",
    },
  },
  {
    path: "/contact",
    name: "contact",
    component: Contact,
    meta: {
      title: "contact",
    },
    props: {
      slug: "contact",
    },
  },
  {
    path: "/contact/:location",
    name: "contact-location",
    component: SimplePage,
    props: {
      slug: "contact",
    },
  },
  {
    path: "/our-work/:name",
    name: "case-page",
    component: Case,
    props: {
      slug: "our-work",
    },
  },
  {
    path: "/jobs/:name",
    name: "jobs",
    component: Jobs,
  },
  {
    path: "/leadership",
    name: "leadership",
    component: Leadership,
  },
  {
    path: "/landing-page/:name",
    name: "landing-page",
    component: LandingPage,
    props: {
      slug: "landing-page",
    },
  },
  {
    path: "/:category/:name",
    name: "article-page",
    component: Article,
  },
  {
    path: "*",
    name: "page-not-found",
    component: PageNotFound,
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/emea.js